import { cn } from 'lib/helpers/utility';

import StepSidebar from '../Sidebar/Sidebar';
import AssistanceCard from '../SmartSuggestions/AssistanceCard';
import SmartSuggestions from '../SmartSuggestions/SmartSuggestions';

const StepperSidebar = ({
  stepsState,
  phases,
  hiddenSubstepCodes,
  isNarrowScreen,
  sidebarOpen,
  closeSidebar,
  isEnteringFromIntro,
  smartSuggestions,
  isAdmin,
  practiceId,
  onExpandStep,
  onCollapseStep,
  onActivateStep,
  onNavigateSubstep
}) => {
  const sidebarContent = (isNarrow) => (
    <>
      <div
        className={cn(
          'stepper-sidebar flex min-h-0 flex-1 flex-col',
          isEnteringFromIntro && 'entering'
        )}>
        <StepSidebar
          stepsState={stepsState}
          phases={phases}
          hiddenSubstepCodes={hiddenSubstepCodes}
          onExpandStep={onExpandStep}
          onCollapseStep={isNarrow ? undefined : onCollapseStep}
          onActivateStep={(code) => {
            onActivateStep(code);
            if (isNarrow) {
              closeSidebar();
            }
          }}
          onNavigateSubstep={(code) => {
            onNavigateSubstep(code);
            if (isNarrow) {
              closeSidebar();
            }
          }}
        />
      </div>
      <div
        className={cn(
          'stepper-smart-suggestions flex-shrink-0',
          isEnteringFromIntro && 'entering'
        )}>
        <SmartSuggestions smartSuggestions={smartSuggestions} />
      </div>
      <div
        className={cn('stepper-assistance-card flex-shrink-0', isEnteringFromIntro && 'entering')}>
        <AssistanceCard isAdmin={isAdmin} practiceId={practiceId} />
      </div>
    </>
  );

  return (
    <>
      {!isNarrowScreen && (
        <aside className="flex h-full w-80 flex-none flex-col gap-4 backdrop-blur-sm">
          {sidebarContent(false)}
        </aside>
      )}

      {isNarrowScreen && sidebarOpen && (
        <div
          onClick={closeSidebar}
          className="fixed inset-0 z-[100] bg-black/30 backdrop-blur-[2px] transition-opacity duration-300"
        />
      )}

      {isNarrowScreen && (
        <aside
          className={cn(
            'fixed left-0 top-0 z-[110] flex h-full w-80 flex-col gap-4 bg-transparent p-4 transition-transform duration-300 ease-in-out',
            sidebarOpen ? 'translate-x-0' : '-translate-x-full'
          )}>
          {sidebarContent(true)}
        </aside>
      )}
    </>
  );
};

export default StepperSidebar;
